import axios from 'axios';
import config from '../config/config';
import {receiveAvailableProjects} from './projectAction';
import {AUTHORIZATION_RECEIVE_LOGIN, AUTHORIZATION_RECEIVE_LOGIN_ERROR, AUTHORIZATION_REQUEST_LOGIN, AUTHORIZATION_LOGOUT, AUTHORIZATION_RECEIVE_LOGIN_ROLE_ERROR} from "../config/actions";

export function login(username, password) {
    return dispatch => {
        dispatch(requestLogin());
        axios(config.server.endpoint + 'login', {
            method: 'post',
            data: {
                username: username ? username : '',
                password: password ? password: ''
            }
        }).then((response) => {
            if (response.status === 200) {
                if(Array.isArray(response.data.roles) && response.data.roles.find((el) => {return ['ROLE_USER', 'ROLE_ADMIN'].indexOf(el) >= 0})) {
                    dispatch(receiveLogin(true, response.data.access_token, response.data.username, response.data.roles));
                    dispatch(receiveAvailableProjects(response.data.availableProjects));
                } else {
                    dispatch(receiveLoginRoleError())
                }
            }
        }).catch((error) => {
            //if (error.response && (error.response.status === 401 || error.response.status === 400)) {
                dispatch(receiveLoginError());
            //}
        })
    }
}

export function requestLogin() {
    return {
        type: AUTHORIZATION_REQUEST_LOGIN
    }
}

export function receiveLogin(success, accessToken, username, roles) {
    return {
        type: AUTHORIZATION_RECEIVE_LOGIN,
        success,
        accessToken,
        username,
        roles
    }
}

export function receiveLoginError() {
    return {
        type: AUTHORIZATION_RECEIVE_LOGIN_ERROR
    }
}

export function receiveLoginRoleError() {
    return {
        type: AUTHORIZATION_RECEIVE_LOGIN_ROLE_ERROR
    }
}

export function logout() {
    localStorage.clear();
    return {
        type: AUTHORIZATION_LOGOUT
    }
}
